function u(e, n) {
  return e?.[n];
}
var a = u;
export {
  a as _
};
//# sourceMappingURL=_getValue.mjs.map
